import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import type {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";
import type {WorkspaceCapabilityUdoTemplateConfiguration} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityUdoTemplateConfiguration";
import {DomainAggregateWorkspaceCapabilityUdoTemplateKey} from "./DomainAggregateWorkspaceCapabilityUdoTemplateKey";
import {z as zod} from "zod";

export type DomainAggregateWorkspaceCapabilityUdoBindings = WorkspaceCapabilityUdoTemplateConfiguration<WorkspaceCapabilityType.domainAggregate> & {
    fixedUdoTemplates: {
        [DomainAggregateWorkspaceCapabilityUdoTemplateKey.template]: {
            udoAdditionalColumnIds: {
                configuration: Uuid;
                domainAggregateName: Uuid;
                status: Uuid;
            };
        };
    };
};

export const domainAggregateWorkspaceCapabilityUdoBindingsValidator = zod.strictObject({
    fixedUdoTemplates: zod.strictObject({
        [DomainAggregateWorkspaceCapabilityUdoTemplateKey.template]: zod.strictObject({
            udoAdditionalColumnIds: zod.strictObject({status: uuidZodValidator, configuration: uuidZodValidator, domainAggregateName: uuidZodValidator}),
            udoTemplateId: uuidZodValidator,
        }),
    }),
}) satisfies zod.ZodType<DomainAggregateWorkspaceCapabilityUdoBindings>;
